export default __webpack_public_path__ + "static/char-v-02-de7c063efac26815ed2bb7ce5e10f09a.webp";